var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#agent_svg__clip0)",
    fill: "#3A50F3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.702 24.335h-.923c-5.34 0-9.685 4.345-9.685 9.685V36h5.302v-4.242h2.12V36h3.773l2.61-6.962a5.31 5.31 0 01-3.197-4.703zM24.222 24.335H23.3a5.31 5.31 0 01-3.197 4.703L22.712 36h3.773v-4.242h2.12V36h5.303v-1.98c0-5.34-4.345-9.685-9.686-9.685zM15.55 36h4.894l-2.447-6.524L15.551 36zM14.82 23.715v.455a3.181 3.181 0 106.363 0v-.455c-1.943.82-4.42.82-6.363 0zM18 17.972h-6a6.365 6.365 0 0012.362-2.12V11.61a6.363 6.363 0 10-12.725 0v4.241h6.362v2.121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.64 15.851H9.52V11.61H7.397v6.362h4.605c-.394-1.114-.35-1.982-.363-2.12zM26.484 11.61v2.12h2.121v-2.12h-2.12zM18 2.066c4.32 0 7.895 3.243 8.418 7.423h2.134C26.941-3.168 9.056-3.158 7.45 9.489h2.134c.524-4.18 4.099-7.423 8.418-7.423z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "agent_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/agent.c669e88c5136f986ad66917f2ca00f16.svg";
export { SvgAgent as ReactComponent };